import { useState } from "react";
import { Icono } from "./ui/Iconos";

export const InputBusqueda = ({ ejecutar }) => {
  const [valor, setValor] = useState("");

  return (
    <div className="input-group" style={{ width: "250px", height: "20px" }}>
      <input
        type="text"
        className="form-control"
        placeholder="Búsqueda"
        id="inputBusquedaRE"
        aria-describedby="button-addon2"
        style={{ height: "30px", fontSize: "14px" }}
        onChange={(e) => {
          setValor(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            ejecutar(valor);
          }
        }}
      />
      <button
        onClick={() => {
          ejecutar(valor);
        }}
        className="btn btn-dark d-flex align-items-center justify-content-center p-0"
        type="button"
        id="button-addon2"
        style={{ height: "30px", width: "34px" }}
      >
        <Icono iconName="lupa" />
      </button>
    </div>
  );
};

export const InputBusquedaMonitor = ({ ejecutar, searchDisabled }) => {
  const [text, setText] = useState("");

  return (
    <div className="input-group" style={{ width: "250px", height: "20px" }}>
      <input
        type="text"
        className="form-control"
        placeholder="Búsqueda"
        aria-describedby="button-addon2"
        style={{ height: "30px", fontSize: "14px" }}
        onChange={(e) => {
          setText(e.target.value);
          if (e.target.value==="") {
            ejecutar('');
          }
        }}
        disabled={searchDisabled}
      />
      <button
        className={`btn btn-${text.length>3 ? 'activado' : 'desactivado'} d-flex align-items-center justify-content-center p-0`}
        type="button"
        id="button-addon2"
        style={{ height: "30px", width: "34px" }}
        disabled={text.length <= 3 ? true : false}
        onClick={() => {
          if (text.length > 3) {
            ejecutar(text);
          }
        }}
      >
        <Icono iconName="lupa" />
      </button>
    </div>
  );
};
